<div class="card" [ngClass]="noBorder ? 'card-no-border' : null">
  <div *ngIf="title" class="card_header">
    <div class="card_header-left">
      <img *ngIf="iconSrc" class="card_icon" [src]="iconSrc" alt="" />
      <div class="card_header-content">
        <h3 class="card_title">{{ title }}</h3>
        <p *ngIf="description" class="card_description">{{ description }}</p>
      </div>
    </div>
    <ng-content select="[header-right]"></ng-content>
    <ng-container *ngIf="isEditIcon">
      <img
        src="./assets/images/ic-edit.png"
        alt="ic-edit"
        class="edit-icon"
        (click)="editIconClicked.emit()"
      />
    </ng-container>
  </div>
  <div class="card_body" [ngClass]="{'card_body--collapsible': isCollapsible}">
    <div
      class="main-content"
      [ngClass]="{ 'main-content__hidden': !isContentVisible }"
    >
      <ng-content></ng-content>
    </div>
    <div
      class="show-hide-btn"
      *ngIf="isCollapsible"
      (click)="toggleVisibleState()"
      [ngClass]="{ 'show-hide-btn__visible': isContentVisible }"
      [pTooltip]="isContentVisible ? 'Hide Content' : 'Show Content'"
    >
      <img src="./assets/images/ic-chevron.svg" alt="ic-chevron" />
    </div>
  </div>
</div>
